export const TIMEZONES_LIST = [
  {
    label: 'International Date Line West',
    value: 'Etc/GMT+12',
    offset: '-12',
  },
  {
    label: 'American Samoa',
    value: 'Pacific/Pago_Pago',
    offset: '-11',
  },
  {
    label: 'Midway Island',
    value: 'Pacific/Midway',
    offset: '-11',
  },
  {
    label: 'Hawaii',
    value: 'Pacific/Honolulu',
    offset: '-10',
  },
  {
    label: 'Alaska',
    value: 'America/Juneau',
    offset: '-09',
  },
  {
    label: 'Pacific Time (US & Canada)',
    value: 'America/Los_Angeles',
    offset: '-08',
  },
  {
    label: 'Tijuana',
    value: 'America/Tijuana',
    offset: '-08',
  },
  {
    label: 'Arizona',
    value: 'America/Phoenix',
    offset: '-07',
  },
  {
    label: 'Mazatlan',
    value: 'America/Mazatlan',
    offset: '-07',
  },
  {
    label: 'Mountain Time (US & Canada)',
    value: 'America/Denver',
    offset: '-07',
  },
  {
    label: 'Central America',
    value: 'America/Guatemala',
    offset: '-06',
  },
  {
    label: 'Central Time (US & Canada)',
    value: 'America/Chicago',
    offset: '-06',
  },
  {
    label: 'Chihuahua',
    value: 'America/Chihuahua',
    offset: '-06',
  },
  {
    label: 'Guadalajara, Mexico City',
    value: 'America/Mexico_City',
    offset: '-06',
  },
  {
    label: 'Monterrey',
    value: 'America/Monterrey',
    offset: '-06',
  },
  {
    label: 'Saskatchewan',
    value: 'America/Regina',
    offset: '-06',
  },
  {
    label: 'Bogota',
    value: 'America/Bogota',
    offset: '-05',
  },
  {
    label: 'Eastern Time (US & Canada)',
    value: 'America/New_York',
    offset: '-05',
  },
  {
    label: 'Indiana (East)',
    value: 'America/Indiana/Indianapolis',
    offset: '-05',
  },
  {
    label: 'Lima, Quito',
    value: 'America/Lima',
    offset: '-05',
  },
  {
    label: 'Atlantic Time (Canada)',
    value: 'America/Halifax',
    offset: '-04',
  },
  {
    label: 'Caracas',
    value: 'America/Caracas',
    offset: '-04',
  },
  {
    label: 'Georgetown',
    value: 'America/Guyana',
    offset: '-04',
  },
  {
    label: 'La Paz',
    value: 'America/La_Paz',
    offset: '-04',
  },
  {
    label: 'Puerto Rico',
    value: 'America/Puerto_Rico',
    offset: '-04',
  },
  {
    label: 'Santiago',
    value: 'America/Santiago',
    offset: '-03',
  },
  {
    label: 'Newfoundland',
    value: 'America/St_Johns',
    offset: '-02:30',
  },
  {
    label: 'Brasilia',
    value: 'America/Sao_Paulo',
    offset: '-03',
  },
  {
    label: 'Buenos Aires',
    value: 'America/Argentina/Buenos_Aires',
    offset: '-03',
  },
  {
    label: 'Greenland',
    value: 'America/Godthab',
    offset: '-02',
  },
  {
    label: 'Montevideo',
    value: 'America/Montevideo',
    offset: '-03',
  },
  {
    label: 'Mid-Atlantic',
    value: 'Atlantic/South_Georgia',
    offset: '-02',
  },
  {
    label: 'Azores',
    value: 'Atlantic/Azores',
    offset: '-01',
  },
  {
    label: 'Cape Verde Is.',
    value: 'Atlantic/Cape_Verde',
    offset: '-01',
  },
  {
    label: 'Edinburgh, London',
    value: 'Europe/London',
    offset: '+00',
  },
  {
    label: 'Lisbon',
    value: 'Europe/Lisbon',
    offset: '+00',
  },
  {
    label: 'Monrovia',
    value: 'Africa/Monrovia',
    offset: '+00',
  },
  {
    label: 'UTC',
    value: 'Etc/UTC',
    offset: '+00',
  },
  {
    label: 'Amsterdam',
    value: 'Europe/Amsterdam',
    offset: '+01',
  },
  {
    label: 'Belgrade',
    value: 'Europe/Belgrade',
    offset: '+01',
  },
  {
    label: 'Berlin',
    value: 'Europe/Berlin',
    offset: '+01',
  },
  {
    label: 'Bern, Zurich',
    value: 'Europe/Zurich',
    offset: '+01',
  },
  {
    label: 'Bratislava',
    value: 'Europe/Bratislava',
    offset: '+01',
  },
  {
    label: 'Brussels',
    value: 'Europe/Brussels',
    offset: '+01',
  },
  {
    label: 'Budapest',
    value: 'Europe/Budapest',
    offset: '+01',
  },
  {
    label: 'Casablanca',
    value: 'Africa/Casablanca',
    offset: '+01',
  },
  {
    label: 'Copenhagen',
    value: 'Europe/Copenhagen',
    offset: '+01',
  },
  {
    label: 'Dublin',
    value: 'Europe/Dublin',
    offset: '+00',
  },
  {
    label: 'Ljubljana',
    value: 'Europe/Ljubljana',
    offset: '+01',
  },
  {
    label: 'Madrid',
    value: 'Europe/Madrid',
    offset: '+01',
  },
  {
    label: 'Paris',
    value: 'Europe/Paris',
    offset: '+01',
  },
  {
    label: 'Prague',
    value: 'Europe/Prague',
    offset: '+01',
  },
  {
    label: 'Rome',
    value: 'Europe/Rome',
    offset: '+01',
  },
  {
    label: 'Sarajevo',
    value: 'Europe/Sarajevo',
    offset: '+01',
  },
  {
    label: 'Skopje',
    value: 'Europe/Skopje',
    offset: '+01',
  },
  {
    label: 'Stockholm',
    value: 'Europe/Stockholm',
    offset: '+01',
  },
  {
    label: 'Vienna',
    value: 'Europe/Vienna',
    offset: '+01',
  },
  {
    label: 'Warsaw',
    value: 'Europe/Warsaw',
    offset: '+01',
  },
  {
    label: 'West Central Africa',
    value: 'Africa/Algiers',
    offset: '+01',
  },
  {
    label: 'Zagreb',
    value: 'Europe/Zagreb',
    offset: '+01',
  },
  {
    label: 'Athens',
    value: 'Europe/Athens',
    offset: '+02',
  },
  {
    label: 'Bucharest',
    value: 'Europe/Bucharest',
    offset: '+02',
  },
  {
    label: 'Cairo',
    value: 'Africa/Cairo',
    offset: '+02',
  },
  {
    label: 'Harare',
    value: 'Africa/Harare',
    offset: '+02',
  },
  {
    label: 'Helsinki',
    value: 'Europe/Helsinki',
    offset: '+02',
  },
  {
    label: 'Jerusalem',
    value: 'Asia/Jerusalem',
    offset: '+02',
  },
  {
    label: 'Kaliningrad',
    value: 'Europe/Kaliningrad',
    offset: '+02',
  },
  {
    label: 'Kyiv',
    value: 'Europe/Kiev',
    offset: '+02',
  },
  {
    label: 'Pretoria',
    value: 'Africa/Johannesburg',
    offset: '+02',
  },
  {
    label: 'Riga',
    value: 'Europe/Riga',
    offset: '+02',
  },
  {
    label: 'Sofia',
    value: 'Europe/Sofia',
    offset: '+02',
  },
  {
    label: 'Tallinn',
    value: 'Europe/Tallinn',
    offset: '+02',
  },
  {
    label: 'Vilnius',
    value: 'Europe/Vilnius',
    offset: '+02',
  },
  {
    label: 'Baghdad',
    value: 'Asia/Baghdad',
    offset: '+03',
  },
  {
    label: 'Istanbul',
    value: 'Europe/Istanbul',
    offset: '+03',
  },
  {
    label: 'Kuwait',
    value: 'Asia/Kuwait',
    offset: '+03',
  },
  {
    label: 'Minsk',
    value: 'Europe/Minsk',
    offset: '+03',
  },
  {
    label: 'Moscow, St. Petersburg',
    value: 'Europe/Moscow',
    offset: '+03',
  },
  {
    label: 'Nairobi',
    value: 'Africa/Nairobi',
    offset: '+03',
  },
  {
    label: 'Riyadh',
    value: 'Asia/Riyadh',
    offset: '+03',
  },
  {
    label: 'Volgograd',
    value: 'Europe/Volgograd',
    offset: '+03',
  },
  {
    label: 'Tehran',
    value: 'Asia/Tehran',
    offset: '+03',
  },
  {
    label: 'Abu Dhabi, Muscat',
    value: 'Asia/Muscat',
    offset: '+04',
  },
  {
    label: 'Baku',
    value: 'Asia/Baku',
    offset: '+04',
  },
  {
    label: 'Samara',
    value: 'Europe/Samara',
    offset: '+04',
  },
  {
    label: 'Tbilisi',
    value: 'Asia/Tbilisi',
    offset: '+04',
  },
  {
    label: 'Yerevan',
    value: 'Asia/Yerevan',
    offset: '+04',
  },
  {
    label: 'Kabul',
    value: 'Asia/Kabul',
    offset: '+04',
  },
  {
    label: 'Ekaterinburg',
    value: 'Asia/Yekaterinburg',
    offset: '+05',
  },
  {
    label: 'Islamabad, Karachi',
    value: 'Asia/Karachi',
    offset: '+05',
  },
  {
    label: 'Tashkent',
    value: 'Asia/Tashkent',
    offset: '+05',
  },
  {
    label: 'Chennai, Kolkata, Mumbai, New Delhi',
    value: 'Asia/Kolkata',
    offset: '+05',
  },
  {
    label: 'Sri Jayawardenepura',
    value: 'Asia/Colombo',
    offset: '+05',
  },
  {
    label: 'Kathmandu',
    value: 'Asia/Kathmandu',
    offset: '+05',
  },
  {
    label: 'Almaty',
    value: 'Asia/Almaty',
    offset: '+06',
  },
  {
    label: 'Astana, Dhaka',
    value: 'Asia/Dhaka',
    offset: '+06',
  },
  {
    label: 'Urumqi',
    value: 'Asia/Urumqi',
    offset: '+06',
  },
  {
    label: 'Rangoon',
    value: 'Asia/Rangoon',
    offset: '+06',
  },
  {
    label: 'Bangkok, Hanoi',
    value: 'Asia/Bangkok',
    offset: '+07',
  },
  {
    label: 'Jakarta',
    value: 'Asia/Jakarta',
    offset: '+07',
  },
  {
    label: 'Krasnoyarsk',
    value: 'Asia/Krasnoyarsk',
    offset: '+07',
  },
  {
    label: 'Novosibirsk',
    value: 'Asia/Novosibirsk',
    offset: '+07',
  },
  {
    label: 'Beijing',
    value: 'Asia/Shanghai',
    offset: '+08',
  },
  {
    label: 'Chongqing',
    value: 'Asia/Chongqing',
    offset: '+08',
  },
  {
    label: 'Hong Kong',
    value: 'Asia/Hong_Kong',
    offset: '+08',
  },
  {
    label: 'Irkutsk',
    value: 'Asia/Irkutsk',
    offset: '+08',
  },
  {
    label: 'Kuala Lumpur',
    value: 'Asia/Kuala_Lumpur',
    offset: '+08',
  },
  {
    label: 'Perth',
    value: 'Australia/Perth',
    offset: '+08',
  },
  {
    label: 'Singapore',
    value: 'Asia/Singapore',
    offset: '+08',
  },
  {
    label: 'Taipei',
    value: 'Asia/Taipei',
    offset: '+08',
  },
  {
    label: 'Ulaanbaatar',
    value: 'Asia/Ulaanbaatar',
    offset: '+08',
  },
  {
    label: 'Osaka, Sapporo, Tokyo',
    value: 'Asia/Tokyo',
    offset: '+09',
  },
  {
    label: 'Seoul',
    value: 'Asia/Seoul',
    offset: '+09',
  },
  {
    label: 'Yakutsk',
    value: 'Asia/Yakutsk',
    offset: '+09',
  },
  {
    label: 'Adelaide',
    value: 'Australia/Adelaide',
    offset: '+09',
  },
  {
    label: 'Darwin',
    value: 'Australia/Darwin',
    offset: '+09',
  },
  {
    label: 'Brisbane',
    value: 'Australia/Brisbane',
    offset: '+10',
  },
  {
    label: 'Canberra, Melbourne',
    value: 'Australia/Melbourne',
    offset: '+10',
  },
  {
    label: 'Guam',
    value: 'Pacific/Guam',
    offset: '+10',
  },
  {
    label: 'Hobart',
    value: 'Australia/Hobart',
    offset: '+10',
  },
  {
    label: 'Port Moresby',
    value: 'Pacific/Port_Moresby',
    offset: '+10',
  },
  {
    label: 'Sydney',
    value: 'Australia/Sydney',
    offset: '+10',
  },
  {
    label: 'Vladivostok',
    value: 'Asia/Vladivostok',
    offset: '+10',
  },
  {
    label: 'Magadan',
    value: 'Asia/Magadan',
    offset: '+11',
  },
  {
    label: 'New Caledonia',
    value: 'Pacific/Noumea',
    offset: '+11',
  },
  {
    label: 'Solomon Is.',
    value: 'Pacific/Guadalcanal',
    offset: '+11',
  },
  {
    label: 'Srednekolymsk',
    value: 'Asia/Srednekolymsk',
    offset: '+11',
  },
  {
    label: 'Auckland, Wellington',
    value: 'Pacific/Auckland',
    offset: '+12',
  },
  {
    label: 'Fiji',
    value: 'Pacific/Fiji',
    offset: '+12',
  },
  {
    label: 'Kamchatka',
    value: 'Asia/Kamchatka',
    offset: '+12',
  },
  {
    label: 'Marshall Is.',
    value: 'Pacific/Majuro',
    offset: '+12',
  },
  {
    label: 'Chatham Is.',
    value: 'Pacific/Chatham',
    offset: '+13',
  },
  {
    label: `Nuku'alofa (UTC+13)`,
    value: 'Pacific/Tongatapu',
    offset: '+13',
  },
  {
    label: 'Samoa',
    value: 'Pacific/Apia',
    offset: '+13',
  },
  {
    label: 'Tokelau Is.',
    value: 'Pacific/Fakaofo',
    offset: '+13',
  },
]
